import { useContext } from 'preact/hooks';

import ResponsiveDirectusImage from '../ResponsiveImage.jsx';
import { findAssetByTitle }    from '../../helpers.js';
import Cta                     from '../Cta.jsx';
import GlobalContext           from '../../context/GlobalContext.js';

const Push = ({ heading, elements, assets, cols }) => {
  const { pathroot } = useContext(GlobalContext);
  const colsClasses = {
    1: 'grid-cols-1',
    2: 'sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2',
    3: 'sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3',
  }
  let count;
  if (!cols) {
    count = elements.length;
  } else {
    count = cols;
  }
  return (
    <div class="sm:px-[7%] md:px-[8%] lg:px-[8%]">
      {heading && <h3 class="headline-36 text-brown mb-[20px]">{heading}</h3>}
      <div class={`grid gap-[8px] gap-y-[50px] auto-rows-auto ${colsClasses[count]}`}>
        {elements.map(element => {
          let asset;
          if (assets) {
            asset = findAssetByTitle(element.image, assets).rlx_responsive_asset_id;
          } else {
            asset = element.image[0].rlx_responsive_asset_id;
          }
          if (pathroot !== '') {
            if (!element.link_to.startsWith(pathroot)) {
              element.link_to = pathroot + element.link_to;
            }
          }
          return (
            <a href={element.link_to} class="group w-full overflow-hidden">
              <div class="relative overflow-hidden">
                <ResponsiveDirectusImage imgClass="group-hover:scale-110 transition-transform duration-700 ease-out"
                                         assetLandscape={asset.asset_landscape}
                                         assetPortrait={asset.asset_portrait} alt={element.heading}/>
              </div>
              <div class={`mt-[10px] pr-[40px] ${count === 1 ? 'sm:max-w-full md:max-w-[70%] lg:max-w-[70%]' : 'max-w-full'}`}>
                {element.subtitle && <p class={`${count <= 2 ? 'fixed-16' : 'legend-16'} font-bold`}>{element.subtitle}</p>}
                <h4 class={`${count <= 2 ? 'headline-36' : 'body-24 font-bold'} text-brown mb-[5px]`}>{element.heading}</h4>
                {element.text && <p class="body-20 text-dark-gray">{element.text}</p>}
                {element.cta && <Cta variant="secondary" href={element.link_to}>{element.cta}</Cta>}
              </div>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default Push;
